import { useMemo } from "react";
import {
  SystemEntityCollections,
  SystemEntityProofreadingStatus,
} from "../../../shared/enums/shared-enums";
import {
  PERSON_CONNECTION_TYPE_LABELS,
  PersonConnection,
} from "../../../types/personConnection";
import { Person } from "../../../types/person";

const usePersonConnectionLogic = (from: Person | null, to: Person | null) => {
  const defaultPersonConnection = useMemo<PersonConnection>(
    () => ({
      _from: from?._id || "",
      _to: to?._id || "",
      _id: "",
      _key: "",
      _rev: "",
      system_person_connection_type: null,
      fromDoc: from
        ? { ...from, _collection: SystemEntityCollections.PERSON }
        : null,
      toDoc: to ? { ...to, _collection: SystemEntityCollections.PERSON } : null,
      entity_status_of_proofreading:
        SystemEntityProofreadingStatus.NOT_PROOFREAD,
      internal_notes: "",
      notes: "",
      attributes_metadata: {},
    }),
    [from, to]
  );

  const getDisplayName = (connection: PersonConnection) =>
    `${connection.system_person_connection_type ? PERSON_CONNECTION_TYPE_LABELS[connection.system_person_connection_type] : "Unknown"} Person Connection`;

  return {
    defaultPersonConnection,
    getDisplayName,
  };
};

export default usePersonConnectionLogic;
